var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenIcon = function SvgOpenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 35"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.228 22.21v3.553h10.99c6.807-.258 12.072-5.808 12.072-12.85C36.29 5.945 30.22.06 23.035.06h-.592C15.455.06 9.68 4.763 7.383 12.303L.03 34.943h3.773l6.965-21.572c1.862-6.11 6.227-9.757 11.675-9.757h.592c5.26 0 9.705 4.26 9.705 9.3 0 5.208-3.944 9.29-8.98 9.296z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.932 12.22)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.661,
    cy: 1.664,
    rx: 1.661,
    ry: 1.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.335,
    cy: 1.664,
    rx: 1.661,
    ry: 1.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.009,
    cy: 1.664,
    rx: 1.661,
    ry: 1.664
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.89 22.203h4.288L4.286 34.937H.036"
  }))));
};
export default SvgOpenIcon;